import { DialogsService } from './dialogs.service';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { NgModule } from '@angular/core';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { SelectDialogComponent } from './select-dialog/select-dialog.component';
import { ControlsModule } from '../controls/controls.module';
import { SafeHtmlPipe } from '../pipes/safe-html.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@NgModule({
	declarations: [AlertDialogComponent, SelectDialogComponent, SafeHtmlPipe],
	imports: [CommonModule, MatDialogModule, MatButtonModule, ControlsModule, TranslateModule],
	exports: [AlertDialogComponent, MatDialogModule],
	providers: [DialogsService, SafeHtmlPipe],
	entryComponents: [AlertDialogComponent, SelectDialogComponent],
})
export class DialogsModule {}
